<template>
<div class="action-buttons" :class="{ 'collapsed': collapsed }" id="policyCaseButton">

  <!-- SWITCH COLLAPSED CARDS MODE -->
  <button type="button" class="btn btn-primary icon-button" id="policyCaseButton-switch-collapsed-mode"
          v-tooltip.left="collapsed ? $options.filters.translate('SHOW_FULL_INFO') : ''"
          @click="$emit('switch-collapsed-mode')">
    <span class="btn-icon" id="policyCaseButton-switch-collapsed-mode-span"><i class="fa" :class="{ 'fa-minus': !collapsed, 'fa-plus': collapsed }" aria-hidden="true" id="policyCaseButton-switch-collapsed-mode-data"></i></span>
    {{ 'SHOW_ONLY_PREMIUMS' | translate }}
  </button>

  <!-- RECALCULATE CASE -->
  <button type="button" class="btn btn-primary icon-button" id="policyCaseButton-case-recalculate"
          v-if="active && !preview && ['ADVISED', 'NOT_ADVISED', 'NOT_CALCULATED', 'REOPENED', 'OPEN'].includes(status)"
          :disabled="hasNoEditRights || isLockedForMe || !formRendered"
          v-tooltip.left="collapsed ? $options.filters.translate(status === 'NOT_CALCULATED' ? 'CALCULATE' : 'RECALCULATE') : ''"
          @click="$emit('case-recalculate')">
    <span class="btn-icon" id="policyCaseButton-case-recalculate-span"><i class="fa fa-refresh" aria-hidden="true" id="policyCaseButton-case-recalculate-data"></i></span>
    {{ status === 'NOT_CALCULATED' ? 'CALCULATE' : 'RECALCULATE' | translate }}
  </button>

  <!-- DOWNLOAD VPI REQUESTS -->
  <button type="button" class="btn btn-primary icon-button" id="policyCaseButton-download-vpi"
          v-if="preview && isAdmin"
          :disabled="!formRendered"
          v-tooltip.left="collapsed ? $options.filters.translate('DOWNLOAD') : ''"
          @click="$emit('download-vpi')">
    <span class="btn-icon" id="policyCaseButton-btn-icon"><i class="fa fa-download" aria-hidden="true" id="policyCaseButton-download-vpi-data"></i></span>
    {{ 'DOWNLOAD' | translate }}
  </button>

  <!-- PREVIEW RECALCULATION -->
  <button type="button" class="btn btn-primary icon-button" id="policyCaseButton-case-preview"
          v-if="active && ['ADVISED', 'NOT_ADVISED', 'REOPENED', 'OPEN'].includes(status)"
          :disabled="hasNoEditRights || !formRendered"
          v-tooltip.left="collapsed ? $options.filters.translate(preview ? 'HIDE_PREVIEW' : 'PREVIEW') : ''"
          @click="$emit('case-preview')">
    <span class="btn-icon" id="policyCaseButton-case-preview-btn-icon"><i class="fa fa-eye" aria-hidden="true" id="policyCaseButton-case-preview-data"></i></span>
    {{ preview ? 'HIDE_PREVIEW' : 'PREVIEW' | translate }}
  </button>

  <!-- MODIFY SELECTED POLICY -->
  <button type="button" class="btn btn-primary icon-button" id="policyCaseButton-selected-modify"
          v-if="active && !preview && ['ADVISED', 'NOT_ADVISED', 'REOPENED', 'OPEN'].includes(status)"
          :disabled="hasNoEditRights || isLockedForMe"
          v-tooltip.left="collapsed ? $options.filters.translate(modifySelected ? 'CANCEL_SELECTION' : 'MODIFY_SELECTED') : ''"
          @click="$emit('selected-modify')">
    <span class="btn-icon" id="policyCaseButton-btn-icon"><i class="fa fa-pencil-square-o" aria-hidden="true" id="policyCaseButton-selected-modify-data"></i></span>
    {{ modifySelected ? 'CANCEL_SELECTION' : 'MODIFY_SELECTED' | translate }}
  </button>

  <!-- ACCEPT SELECTED POLICY -->
  <button type="button" class="btn btn-success icon-button" id="policyCaseButton-case-accept"
          v-if="active && !preview && ['ADVISED', 'NOT_ADVISED', 'REOPENED', 'OPEN'].includes(status)"
          :disabled="hasNoEditRights || isLockedForMe || errorsOnRequestedPolicy || validationsOnSelectedPolicy"
          v-tooltip.left="collapsed ? $options.filters.translate(modifySelected ? 'SAVE_AND_ACCEPT' : 'ACCEPT') : ''"
         @click="$emit('case-accept-clicked')">
    <span class="btn-icon" id="policyCaseButton-case-accept-btn-icon"><i class="fa fa-check" aria-hidden="true" id="policyCaseButton-case-accept-data"></i></span>
    {{ modifySelected ? 'SAVE_AND_ACCEPT' : 'ACCEPT' | translate }}
  </button>

  <!-- REOPEN CASE -->
  <button type="button" class="btn btn-primary icon-button" id="policyCaseButton-case-reopen"
          v-if="active && !preview && ['ACCEPTED', 'ACCEPTED_MANUALLY', 'ARCHIVED'].includes(status)"
          :disabled="hasNoEditRights || isLockedForMe"
          v-tooltip.left="collapsed ? $options.filters.translate('REOPEN') : ''"
          @click="$emit('case-reopen')">
    <span class="btn-icon" id="policyCaseButton-case-reopen-btn-icon"><i class="fa fa-pencil" aria-hidden="true" id="policyCaseButton-case-reopen-data"></i></span>
    {{ 'REOPEN' | translate }}
  </button>

  <!-- CLOSE CASE -->
  <button type="button" class="btn btn-primary icon-button" id="policyCaseButton-case-close"
          v-if="active && !preview && ['ACCEPTED', 'ADVISED', 'ARCHIVED', 'NOT_ADVISED', 'REOPENED', 'OPEN', 'ACCEPTED_MANUALLY'].includes(status)"
          :disabled="hasNoEditRights || isLockedForMe"
          v-tooltip.left="collapsed ? $options.filters.translate('CLOSE_CASE2') : ''"
          @click="$emit('case-close')">
    <span class="btn-icon" id="policyCaseButton-case-close-btn-icon"><i class="fa fa-times" aria-hidden="true" id="policyCaseButton-case-close-data"></i></span>
    {{ 'CLOSE_CASE2' | translate }}
  </button>

  <!-- SEE HISTORY -->
  <button type="button" class="btn btn-primary icon-button" id="policyCaseButton-case-show-history"
          v-if="!preview"
          v-tooltip.left="collapsed ? $options.filters.translate('SEE_HISTORY') : ''"
          @click="$emit('case-show-history')">
    <span class="btn-icon" id="policyCaseButton-case-show-history-btn-icon"><i class="fa fa-clock-o" aria-hidden="true" id="policyCaseButton-case-show-history-data"></i></span>
    {{ 'SEE_HISTORY' | translate }}
  </button>

    <!-- DOWNLOAD PDF -->
  <button type="button" class="btn btn-primary icon-button" id="policyCaseButton-download-case"
          :disabled="validationsOnSelectedPolicy"
          v-tooltip.left="collapsed ? $options.filters.translate('DOWNLOAD_CASE') : ''"
          @click="$emit('download-case')">
    <span class="btn-icon" id="policyCaseButton-download-case-btn-icon"><i class="fa-regular fa-file-pdf" aria-hidden="true" id="policyCaseButton-download-case-data"></i></span>
    {{ 'DOWNLOAD_CASE' | translate }}
  </button>

  <!-- ACCEPTED MANUALLY -->
  <button type="button" class="btn btn-primary icon-button" id="policyCaseButton-accepted-manually"
  v-if="active && !preview && !['ACCEPTED_MANUALLY','CLOSED','ACCEPTED'].includes(status)"
          v-tooltip.left="collapsed ? $options.filters.translate('ACCEPTED_MANUALLY') : ''"
          @click="$emit('accepted-manually-clicked')">
    <span class="btn-icon" id="policyCaseButton-accepted-manually-btn-icon"><i class="fa-solid fa-user-check" aria-hidden="true" id="policyCaseButton-accepted-manually-data"></i></span>
    {{ 'ACCEPTED_MANUALLY' | translate }}
  </button>
  <!-- SAVE POLICY -->
  <button type="button" class="btn btn-primary icon-button" id="policyCaseButton-save-case"
          v-if="active && !preview && !['CLOSED'].includes(status)"
          v-tooltip.left="collapsed ? $options.filters.translate('SAVE_CASE') : ''"
          @click="$emit('save-case')">
    <span class="btn-icon" id="policyCaseButton-save-case-btn-icon"><i class="fa-solid fa-file-export" aria-hidden="true" id="policyCaseButton-save-case-data"></i></span>
    {{ 'SAVE_CASE' | translate }}
  </button>
  <div v-if="hasNoEditRights || isLockedForMe"
       class="not-authorized-warning text-warning" id="policyCaseButton-notAuthorized"
       v-tooltip.left="collapsed ? $options.filters.translate('NOT_AUTHORIZED_TO_EDIT') : ''">
    <i class="fa fa-warning" aria-hidden="true" id="policyCaseButton-notAuthorized-data"></i>
    <span v-if="!collapsed" id="policyCaseButton-notAuthorized-toEdit">{{ 'NOT_AUTHORIZED_TO_EDIT' | translate }}</span>
  </div>

</div>
</template>

<script>
import KeycloakService from '../../service/keycloak/KeycloakService';

export default {
  props: [ 'status', 'active', 'isLockedForMe', 'hasNoEditRights', 'errorsOnRequestedPolicy',
    'validationsOnSelectedPolicy', 'collapsed', 'modifySelected', 'formRendered', 'preview' ],
  computed: {
    isAdmin: function () {
      return KeycloakService.isAdmin();
    }
  }
}
</script>

<style lang="scss" scoped>
  .action-buttons {
    display: flex;
    flex-direction: column;
  }

  .action-buttons:not(.collapsed) .btn + .btn {
    margin-top: 8px;
  }

  .action-buttons.collapsed {
    margin-bottom: -8px;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .action-buttons.collapsed .btn {
    $size: 45px;
    padding-left: $size;
    width: $size;
    height: $size;
  }

  .action-buttons.collapsed .btn-icon {
    padding-top: 10px;
  }

  .not-authorized-warning {
    margin-top: 8px;
    font-size: .9rem;
    line-height: 1.2;
  }

  .collapsed .not-authorized-warning {
    margin-top: 0;
    margin-left: 8px;
    padding-top: 10px;
    width: 45px;
    height: 45px;
    font-size: 1.3rem;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/case/PolicyCaseButtons.vue